export const jackpotsFeedComponentsController = {
  initial: 'controllerIdle',
  states: {
    controllerIdle: {
      on: {
        RELOAD_JACKPOTS_FEED_COMPONENT: {
          target: 'updatingJackpots',
        },
      },
    },
    updatingJackpots: {
      invoke: {
        src: 'updateJackpotsContent',
        onDone: {
          actions: [
            {
              type: 'batchLayoutOperations',
              data: '$event.data.updates',
              meta: {
                selectors: ['$action.data'],
              },
            },
          ],
          target: 'controllerIdle',
        },
      },
    },
  },
};
